import { createApp } from 'vue';
import {
  useTheme,
  fareharborLightTheme,
} from '@fareharbor-com/beacon-vue/themes';
import '@fareharbor-com/beacon-vue/fonts/roboto';

import {
  prepareInterpolateFunction,
  mockTranslationFunctions,
} from './scripts/prepareTranslationScripts';
import { recordVueError } from './services/errorReporting';
import './styles.scss';

import App from './App.vue';

const app = createApp(App);

/*
 * Forward component errors to Honeycomb. Vue hands the error to this handler
 * *instead of* logging it (`@vue/runtime-core` handleError returns as soon as
 * `errorHandler` is set), so the console.error below preserves the output that
 * would otherwise be lost.
 */
app.config.errorHandler = (error, instance, info) => {
  console.error(error);
  recordVueError(error, { instance, info });
};

const renderApp = (isTranslationsLoadFailed) => {
  if (isTranslationsLoadFailed) {
    mockTranslationFunctions();
  }

  prepareInterpolateFunction(window.interpolate);

  app.mixin({
    methods: {
      T: window.T,
      nT: window.nT,
      cT: window.cT,
      interpolate: window.interpolate,
    },
  });

  app.mount('#app');

  // Use the standard dashboard theme from Beacon
  useTheme(fareharborLightTheme);
};

if (window.loadTranslationsStatus.isLoaded) {
  renderApp(window.loadTranslationsStatus.isFailed);
  delete window.loadTranslationsStatus;
} else {
  const listenerFunction = () => {
    renderApp(window.loadTranslationsStatus.isFailed);

    document.removeEventListener(
      window.loadTranslationsStatus.eventName,
      listenerFunction,
    );

    delete window.loadTranslationsStatus;
  };

  document.addEventListener(
    window.loadTranslationsStatus.eventName,
    listenerFunction,
  );
}
